export default __webpack_public_path__ + "static/image5-4abc90bdbaa4b9810b3fab750b8c59f5.png";